/**
 * Utility functions for Carrier Access
 */

const HASH_LINK_SESSION_KEY = "carrier_hashLink";

/**
 * Extract hash link from URL pathname
 * Supports multiple URL patterns:
 * - /carrier-access/{hash}
 * - /carrier-access/{hash}/transports
 * - /carrier-access/{hash}/transports/{id}
 */
export function extractHashLinkFromUrl(): string | null {
    const pathname = window.location.pathname;

    // Pattern matches: /carrier-access/{64-char-hex-hash} with optional trailing parts
    const match = pathname.match(/^\/carrier-access\/([a-f0-9]{64})(?:\/.*)?$/);

    if (match) {
        const hashLink = match[1];
        // Store in sessionStorage for later use
        sessionStorage.setItem(HASH_LINK_SESSION_KEY, hashLink);
        return hashLink;
    }

    // If not found in URL, try to get from sessionStorage
    const storedHashLink = sessionStorage.getItem(HASH_LINK_SESSION_KEY);
    return storedHashLink;
}

/**
 * Get stored hash link from sessionStorage
 */
export function getStoredHashLink(): string | null {
    return sessionStorage.getItem(HASH_LINK_SESSION_KEY);
}

/**
 * Clear stored hash link
 */
export function clearStoredHashLink(): void {
    sessionStorage.removeItem(HASH_LINK_SESSION_KEY);
}
